import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { RolesApiAdapter } from '@modules/configuration/Roles/adapters/RolesApiAdapter';

/**
 * Hook para obtener todos los roles
 * Se usa para mapear current_role_id a nombre de rol
 */
export const useRoles = () => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new RolesApiAdapter(httpClient);

  const {
    data: rolesResponse,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['allRoles'],
    queryFn: () => apiAdapter.getAll(),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    roles: rolesResponse || [],
    isLoading,
    error,
  };
};

